import { atom } from 'jotai';

export const modalOpen = atom<boolean>(false);

export const setModalOpen = atom(modalOpen, (_get, set, value) => {
  set(modalOpen, value);
});

export const isEnterPhoneNumber = atom<boolean>(false);

export const setIsEnterPhoneNumber = atom(isEnterPhoneNumber, (_get, set, value) => {
  set(isEnterPhoneNumber, value);
});

export const isValidateOtp = atom<boolean>(false);

export const setIsValidateOtp = atom(isValidateOtp, (_get, set, value) => {
  set(isValidateOtp, value);
});

export const isVerificationSuccessful = atom<boolean>(false);

export const setIsVerificationSuccessful = atom(isVerificationSuccessful, (_get, set, value) => {
  set(isVerificationSuccessful, value);
});

export const initializePhoneNumberValidation = atom<boolean>(false);

export const setInitializePhoneNumberValidation = atom(initializePhoneNumberValidation, (_get, set, value) => {
  set(initializePhoneNumberValidation, value);
});
